module.exports = __webpack_public_path__ + "img/pace3.7c558d6.jpg";